import { defineMessages } from 'react-intl';

export default defineMessages({
    noInfo: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorPriorCarrier.noInfo',
        defaultMessage: 'No information is available to display'
    },
    priorCarrier: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorPriorCarrier.Prior Carrier',
        defaultMessage: 'Prior Carrier'
    },
    policyNumber: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorPriorCarrier.POLICY #',
        defaultMessage: 'POLICY #'
    },
    status: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorPriorCarrier.STATUS',
        defaultMessage: 'STATUS'
    },
    bodilyInjuryLimits: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorPriorCarrier.BODILY INJURY LIMITS',
        defaultMessage: 'BI LIMITS'
    },
    propertyDamageLimits: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorPriorCarrier.PROPERTY DAMAGE LIMITS',
        defaultMessage: 'PD LIMITS'
    },
    timeWithPriorCarrier: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorPriorCarrier.TIME WITH PRIOR CARRIER',
        defaultMessage: 'TIME WITH CARRIER'
    },
    lastCancelDate: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorPriorCarrier.LAST CANCEL DATE',
        defaultMessage: 'LAST CANCELED'
    }
});